import translations from '../../Data/translations.json';
import Language from './Language';
import { isEmpty } from 'lodash/lang';

/**
 * @param key
 * @param replace
 * @return {*}
 */
export default (key, replace) => {
    let locale = Language.get();

    if (!locale) {
        locale = 'en';
    }

    let translation, translationNotFound = true;

    try {
        translation = key.split('.').reduce((t, i) => t[i] || null, translations[locale]);

        if (translation) {
            translationNotFound = false;
        }
    } catch (e) {
        translation = key
    }

    if(translationNotFound){
        translation = translations[locale][key]
            ? translations[locale][key]
            : key;
    }

    if(isEmpty(replace)) {
        return translation;
    }

    Object.keys(replace)
        .forEach(key => {
            translation = translation.replace(':' + key, replace[key]);
        });

    return translation;
}
